import { useRouter } from 'next/router'

import { IUL_LP_URL, isGetEthosQuoteDomain } from '@/constants'

export const useIsSpecialSingleCTA = () => {
  const { asPath } = useRouter()
  const pathnameWithoutQuery = asPath.split('?')[0]

  const isGetEthosQuoteLandingPage =
    isGetEthosQuoteDomain() && pathnameWithoutQuery === '/'

  const isSpecialSingleCTAPage = pathnameWithoutQuery.includes(IUL_LP_URL)

  return isGetEthosQuoteLandingPage || isSpecialSingleCTAPage
}
